import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { defineMailTemplate } from '@adornis/mails/db/mail-template-definition.js';
import { EmailAttachments, EmailType, EmailVars } from '@ils/mails/emailEnums.js';
import { ExamType } from '@ils/static/enums.js';
import { ILSFile } from '@legacy-db/ils-files.js';
import { html } from 'lit';
import { DateTime } from 'luxon';
import { getSalutation } from '../utils.js';

export const StaffReminderMail = defineMailTemplate(EmailType.STAFF_REMINDER, {
  displayName: EmailType.STAFF_REMINDER,
  defaultTemplate: {
    subject: `Erinnerung zur Prüfung am {{${EmailVars.DATE}}}`,
    content: `Hallo {{${EmailVars.SALUTATION}}} {{${EmailVars.LASTNAME}}},<p></p><p>es gibt nächste Woche am {{${EmailVars.DATE}}} eine Prüfung von {{${EmailVars.START_TIME}}} bis {{${EmailVars.END_TIME}}}.</p><p>Ihr FaMed Team</p>`,
    footer: '',
  },
  variables: [
    EmailVars.FIRSTNAME,
    EmailVars.LASTNAME,
    EmailVars.SALUTATION,
    EmailVars.DATE,
    EmailVars.START_TIME,
    EmailVars.END_TIME,
  ],
  attachments: [EmailAttachments.EXAMDAY_ICS, EmailAttachments.INFO_PDF],
  editorHint: () => html`
    <p>
      Wird gesendet an:<br />
      - Prüfungszentrum
    </p>
    <p>
      Wann:<br />
      - wenn der nächste Prüfungstag in einer Woche ansteht
    </p>
  `,
  getMailData: (
    user: { _id: string; username: string; email: string; ecommerce?: Maybe<{ firstName: string; lastName: string }> },
    examDay: { _id: string; start: Date; end: Date; examType: Maybe<ExamType> },
  ) => ({
    data: {
      [EmailVars.FIRSTNAME]: user.ecommerce?.firstName ?? '---',
      [EmailVars.LASTNAME]: user.ecommerce?.lastName ?? user.username,
      [EmailVars.SALUTATION]: getSalutation(user),
      [EmailVars.DATE]: DateTime.fromJSDate(examDay.start).toFormat('dd.LL.yyyy'),
      [EmailVars.START_TIME]: DateTime.fromJSDate(examDay.start).toFormat('hh:mm') + ' Uhr',
      [EmailVars.END_TIME]: DateTime.fromJSDate(examDay.end).toFormat('hh:mm') + ' Uhr',
    },
    attachments: {
      [EmailAttachments.EXAMDAY_ICS]: A.absoluteUrl('/api/ics/examday/' + examDay._id + '.ics'),
      [EmailAttachments.INFO_PDF]: ILSFile.getDownloadLink('info_famed') + '/info_famed.pdf',
    },
    scope: examDay.examType ?? ExamType.FAMED,
  }),
});
